/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from 'react';
import { connect } from 'react-redux';
/* import { Link, Switch, Route } from "react-router-dom";
 */ import objectPath from 'object-path';
import { withRouter } from 'react-router-dom';
/* import { LayoutContextConsumer } from "../LayoutContext";
 */ import * as builder from '../../modules/builder';

class SubHeader extends React.Component {
  render() {
    const {
      subheaderCssClasses,
      subheaderContainerCssClasses,
      subheaderMobileToggle,
      title,
      Component,
      children
    } = this.props;
    return (
      <div id='kt_subheader' className={`header col-12`}>
        {subheaderMobileToggle && (
          <button
            className='kt-subheader__mobile-toggle kt-subheader__mobile-toggle--left'
            id='kt_subheader_mobile_toggle'
          >
            <span />
          </button>
        )}

        <div className='row justify-content-between'>
          <div className='col-sm-12 col-md-4'>
            <h2 className='kt-subheader__title '>{title}</h2>
            {Component && (
              <>
                <Component />
              </>
            )}
            {/*             <LayoutContextConsumer>
             */}
            {/*  {({ subheader: { title } }) => <h1>{title}</h1>} */}
            {/*             </LayoutContextConsumer>
             */}
          </div>
          <div className='col-sm-12 col-md-4'>
            <div className='col save--action text-right'>{children}</div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = store => {
  return {
    config: store.builder.layoutConfig,
    menuConfig: store.builder.menuConfig,
    subheaderMobileToggle: objectPath.get(
      store.builder.layoutConfig,
      'subheader.mobile-toggle'
    ),
    subheaderCssClasses: builder.selectors.getClasses(store, {
      path: 'subheader',
      toString: true
    }),
    subheaderContainerCssClasses: builder.selectors.getClasses(store, {
      path: 'subheader_container',
      toString: true
    })
  };
};

export default withRouter(connect(mapStateToProps)(SubHeader));
